// extracted by mini-css-extract-plugin
export default {"dadosRegistrados":"Admin3_dadosRegistrados__Hdgh9","button":"Admin3_button__t47KA"};